/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MatchingOption,
    MatchingOptionFromJSON,
    MatchingOptionFromJSONTyped,
    MatchingOptionToJSON,
} from './MatchingOption';
import {
    SearchScope,
    SearchScopeFromJSON,
    SearchScopeFromJSONTyped,
    SearchScopeToJSON,
} from './SearchScope';

/**
 * プレスリリースを関連度スコア順で取得するAPIのリクエスト
 * @export
 * @interface SearchRelevanceScoreOrderPressReleaseRequest
 */
export interface SearchRelevanceScoreOrderPressReleaseRequest {
    /**
     * 検索キーワード
     * @type {string}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    searchKeyword?: string;
    /**
     * ビジネスカテゴリlv1のIDリスト
     * @type {Array<string>}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    busiCateLv1Ids?: Array<string>;
    /**
     * 企業カテゴリのIDリスト
     * @type {Array<string>}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    companyCateIds?: Array<string>;
    /**
     * エリアのIDリスト
     * @type {Array<number>}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    regionIds?: Array<number>;
    /**
     * 
     * @type {SearchScope}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    searchScope?: SearchScope;
    /**
     * 
     * @type {MatchingOption}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    matchingOption?: MatchingOption;
    /**
     * 取得開始日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    startDate?: string;
    /**
     * 取得終了日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    endDate?: string;
    /**
     * 次のデータを取得する開始点となる識別子. {score}_{company_id}_{release_id}という形式
     * @type {string}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    cursor?: string;
    /**
     * 取得するプレスリリース数
     * @type {number}
     * @memberof SearchRelevanceScoreOrderPressReleaseRequest
     */
    limit?: number;
}

export function SearchRelevanceScoreOrderPressReleaseRequestFromJSON(json: any): SearchRelevanceScoreOrderPressReleaseRequest {
    return SearchRelevanceScoreOrderPressReleaseRequestFromJSONTyped(json, false);
}

export function SearchRelevanceScoreOrderPressReleaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRelevanceScoreOrderPressReleaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchKeyword': !exists(json, 'search_keyword') ? undefined : json['search_keyword'],
        'busiCateLv1Ids': !exists(json, 'busi_cate_lv1_ids') ? undefined : json['busi_cate_lv1_ids'],
        'companyCateIds': !exists(json, 'company_cate_ids') ? undefined : json['company_cate_ids'],
        'regionIds': !exists(json, 'region_ids') ? undefined : json['region_ids'],
        'searchScope': !exists(json, 'search_scope') ? undefined : SearchScopeFromJSON(json['search_scope']),
        'matchingOption': !exists(json, 'matching_option') ? undefined : MatchingOptionFromJSON(json['matching_option']),
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'endDate': !exists(json, 'end_date') ? undefined : json['end_date'],
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SearchRelevanceScoreOrderPressReleaseRequestToJSON(value?: SearchRelevanceScoreOrderPressReleaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'search_keyword': value.searchKeyword,
        'busi_cate_lv1_ids': value.busiCateLv1Ids,
        'company_cate_ids': value.companyCateIds,
        'region_ids': value.regionIds,
        'search_scope': SearchScopeToJSON(value.searchScope),
        'matching_option': MatchingOptionToJSON(value.matchingOption),
        'start_date': value.startDate,
        'end_date': value.endDate,
        'cursor': value.cursor,
        'limit': value.limit,
    };
}

